import { Component, effect, input, ChangeDetectionStrategy } from '@angular/core';
import { MutexValidator } from '../../input/validator/mutex-validator';
import { Register } from '@xanadu/core';

@Component({
    selector: 'app-select-meta',
    templateUrl: './select-meta.component.html',
    styleUrls: ['./select-meta.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('select-meta')
export class SelectMetaComponent {
    model = input<any>();

    metaLabel: any;
    metaValue: any;

    metaMultiple: any = { id: 'multiple', name: 'Multiple', info: 'Allow multiple selection' };

    constructor() {
        effect(() => {
            const model = this.model();

            if (model) {
                model?.meta?.formGroup.setValidators([MutexValidator(['label', 'value'])]);
                this.metaLabel = {
                    id: 'label',
                    name: 'Label',
                    info: 'Option label field name, it can be changed only if select options list is empty.',
                    mandatory: true,
                    readonly: model.type.data && model.type.data.options && model.type.data.options.length > 0
                };
                this.metaValue = {
                    id: 'value',
                    name: 'Value',
                    info: 'Option value field name, it can be changed only if select options list is empty.',
                    mandatory: true,
                    readonly: model.type.data && model.type.data.options && model.type.data.options.length > 0
                };
            }
        });
    }
}
